import NUMBER from './number';

export default {
  number: NUMBER,
};
